export default "__VITE_ASSET__WzirIF7a__"